module.exports = __webpack_public_path__ + "static/affiliate-header-95313ca9618cd48396455a454d363289.jpg";